import { number, string } from "prop-types";
import { useMemo } from "react";

import styled from "styled-components";

import { typographyProps } from "NavBar/components/NavLink";

import FnrTypography from "UI/FnrTypography";
import { colorsByFunction } from "UI/colors";

import { formatNumberWithCommas } from "Utilities/Number/formatNumberWithCommas";
import { accentShadow } from "Utilities/interpolations/shadow";

const mainColor = colorsByFunction.textLight;

const numberTypographyProps = {
  ...typographyProps,
  fontSize: "md",
  shadow: false,
  type: "number",
  bold: true,
};

const formatCountValue = (value) => {
  if (value >= 1000) {
    return formatNumberWithCommas(value);
  }
  return value;
};

const Count = ({ count, max, accentColor }) => {
  const formattedCount = useMemo(() => formatCountValue(count), [count]);
  const formattedMax = useMemo(() => formatCountValue(max), [max]);
  const isUnlimited = max === null || max === undefined;

  return (
    <CountContainer>
      <CountNumber>
        <FnrTypography {...numberTypographyProps} color={accentColor}>
          {formattedCount}
        </FnrTypography>
      </CountNumber>
      {(isUnlimited || max > 0) && (
        <CountMax>
          <FnrTypography {...numberTypographyProps}>
            {isUnlimited ? "∞" : formattedMax}
          </FnrTypography>
        </CountMax>
      )}
    </CountContainer>
  );
};

Count.propTypes = { count: number, max: number, accentColor: string };

const CountContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${mainColor};
  border-radius: 24px;
  overflow: hidden;
  ${accentShadow}
  transform-origin: right;
  margin-right: 4px;
  flex-shrink: 0;
  transform: scale(0.75);
`;
const CountNumber = styled.div`
  padding: 2px 7px;
  background: ${mainColor};
  position: relative;
  font-weight: bold;
  &:not(:last-child) {
    padding-right: 3px;
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: -3px;
      bottom: -3px;
      width: 6px;
      left: 100%;
      background: ${mainColor};
      transform: rotate(15deg);
      margin-left: -3px;
      z-index: -1;
    }
  }
`;
const CountMax = styled.div`
  padding: 2px 7px;
  padding-left: 8px;
`;

export default Count;
